import type { GameConfig } from '@hollowveil/shared';
import {
  firstQuest,
  secondQuest,
  thirdQuest,
  fourthQuest,
  fifthQuest,
  sixthQuest,
  seventhQuest,
  eighthQuest,
  ninthQuest,
  allQuests,
} from './quests';
import { allRooms } from './rooms';

// Re-export quests for backward compatibility
export {
  firstQuest,
  secondQuest,
  thirdQuest,
  fourthQuest,
  fifthQuest,
  sixthQuest,
  seventhQuest,
  eighthQuest,
  ninthQuest,
  allQuests,
};

// Re-export rooms for backward compatibility
export * from './rooms';

export const demoConfig: GameConfig = {
  title: 'Hollowveil - Demo',
  version: '0.1.0',
  startingRoomId: 'room_village_house',
  character: {
    id: 'player',
    name: 'Aelindra',
    modelId: 'character_child',
    animations: {
      idle: 'idle',
      walk: 'walk',
      interact: 'interact',
    },
    moveSpeed: 4,
  },
  rooms: allRooms,
  quests: [firstQuest, secondQuest, thirdQuest, fourthQuest, fifthQuest, sixthQuest, seventhQuest, eighthQuest, ninthQuest],
};
